
import { AppUtilityService } from '../../core/services/app-utility.service';
import { BehaviorSubject ,  Observable } from 'rxjs';
import { ConfigService } from '../../core/services/config.service';
import { DataStoreService } from '../../core/services/datastore.service';
import { HttpStatus } from '../../core/model/http-status-enum.model';
import { Injectable } from '@angular/core';
import { LmsLoaderService } from '../../core/services/lms-loader.service';
import { LmsLoggerService } from '../../core/services/lms-logger.service';
import { MessageHandlerService } from '../../core/services/message-handler.service';
import { OutlyingPointResponse } from './../../core/model/outlying-point-response.model';
import { Router } from '@angular/router';
import { Tab } from '../../core/model/tab.model';
import { TabData } from '../../core/model/tab-data.model';
import { HttpClient } from '@angular/common/http';

/**
 * @export
 * @class OutlyingPointService
 */
@Injectable()
export class OutlyingPointService {

  private RESOURCE_URL = '/commonops/outlyingpoints'; // Rest Service Hit URL
  private configData: any; // Get Data from Config Service
  loadData: Observable<OutlyingPointResponse>; // Observable Used to get Data for Outlying Point
  private loadDataBS: BehaviorSubject<OutlyingPointResponse>; // Behaviour Subject Used to detect any changes to Data

  /**
   * Creates an instance of OutlyingPointService.
   * @param {HttpClient} http
   * @param {ConfigService} configService
   * @param {DataStoreService} dataStoreService
   * @param {LmsLoggerService} lmsLoggerService
   * @param {Router} router
   * @param {LmsLoaderService} lmsLoaderService
   * @param {MessageHandlerService} messageHandlerService
   * @param {AppUtilityService} appUtilityService
   * @memberof OutlyingPointService
   */
  constructor(private http: HttpClient,
    private configService: ConfigService,
    private dataStoreService: DataStoreService,
    private lmsLoggerService: LmsLoggerService,
    private router: Router,
    private lmsLoaderService: LmsLoaderService,
    private messageHandlerService: MessageHandlerService, private appUtilityService: AppUtilityService) {
    this.configData = this.configService.getConfigData();
    this.loadDataBS = <BehaviorSubject<OutlyingPointResponse>>new BehaviorSubject({});
    this.loadData = this.loadDataBS.asObservable();
  }


  /**
   * @param {Tab} tab
   * @returns
   * @memberof OutlyingPointService
   */
  load(tab: Tab) {
    let outlyingPointData: OutlyingPointResponse;
    let foundInDataStore = false;
    if (tab && tab.tabSearchParameter) {
      if (tab.tabSearchParameter.searchText) {
        tab.tabSearchParameter.searchText = tab.tabSearchParameter.searchText.trim();
      } else {
        this.lmsLoaderService.hideLoader();
        return;
      }
      if (tab.subTypeDetail[tab.subType.toLowerCase()].status === this.configData.tabStatus.error) {
        this.lmsLoaderService.hideLoader();
        return;
      }
      if (tab.subTypeDetail[tab.subType.toLowerCase()].status !== this.configData.tabStatus.refresh) {
        const tabData = this.dataStoreService.getValue(tab);
        if (tabData) {
          outlyingPointData = <OutlyingPointResponse>(tabData.data[tab.subType]);
          foundInDataStore = true;
          this.lmsLoaderService.hideLoader();
          this.loadDataBS.next(outlyingPointData);
        }
      } else {
        foundInDataStore = false;
      }
      if (!foundInDataStore) {
        this.lmsLoaderService.showLoader();
        const deskId = tab.tabSearchParameter.searchText;
        const timeFiller = tab && tab.tabSearchParameter && tab.tabSearchParameter.spinnerVal ? tab.tabSearchParameter.spinnerVal : 24;
        this.lmsLoggerService.logInfo('OutlyingPointService=>load service call starts');
        this.http.get(`${this.configData.urls.API_URL}${this.RESOURCE_URL}?opr=INQU&desk=${deskId}&tf=${timeFiller}`)
          .subscribe(data => {
            this.subscribeData(tab, data);
            this.lmsLoggerService.logInfo('OutlyingPointService=>load service call ends');
          },
          error => {
            this.errorOccuredWhileGettingData(error);
          });
      }

    } else {
      this.lmsLoaderService.hideLoader();
      this.loadDataBS.next(null);
    }
  }

  /**
   * @private
   * @param {Tab} tab
   * @param {*} data
   * @memberof OutlyingPointService
   */
  private subscribeData(tab: Tab, data: any) {
    const lOutlyingPointData: OutlyingPointResponse = data;
    const tabData = <TabData>({
      id: tab.id,
      subType: tab.subType
    });
    tabData.data = tabData.data ? tabData.data : {};
    tabData.data[tab.subType] = lOutlyingPointData;
    this.lmsLoaderService.hideLoader();
    lOutlyingPointData.refreshTime = data.refreshTime;
    lOutlyingPointData.httpStatus = HttpStatus.OK;
    lOutlyingPointData.tabId = tab.id;
    lOutlyingPointData.errorMessage = '';
    tab.subTypeDetail.data.status = 'loaded';
    tab.subTypeDetail.data.message = '';
    this.dataStoreService.putValue(tab, tabData);
    this.loadDataBS.next(lOutlyingPointData);
    this.lmsLoggerService.logInfo('OutlyingPointService => load()',
      `Outlying Point Data Fetch Successfull for ${JSON.stringify(tab)}`);
  }


  /**
   * Error Method when we get Error From Service
   * @private
   * @param {*} error
   * @memberof OutlyingPointService
   */
  private errorOccuredWhileGettingData(error: any) {
    this.lmsLoaderService.hideLoader();
    const lOutlyingPointData = <OutlyingPointResponse>({
      httpStatus: error.status,
      errorMessage: this.appUtilityService.getHttpErroMessage(error, false)
    });
    this.loadDataBS.next(lOutlyingPointData);
    this.lmsLoggerService.logError('OutlyingPointService => load()', this.appUtilityService.getHttpErroMessage(error, false));
  }

  /**
   * @memberof OutlyingPointService
   */
  cleanBehaviourSubject() {
    this.loadDataBS.next(null);
  }

}
